import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import { FDBox, FDSecondaryActionButton, FDTooltip } from '@facet-wealth/design';

const useStyles = buildUseStyles('IHaveAQuestionButton', (() => ({
  root: {},
})));

const IHaveAQuestionButton = ({
  className,
  completed,
  handleQuestionOnClick,
}) => {
  const classes = useStyles();

  if (completed) {
    return null;
  }

  return (
    <FDBox
      className={classNames(classes.root, className)}
    >
      <FDTooltip title={'Ask your planner a question, or let them know if anything has changed that would affect this action'}>
        <FDSecondaryActionButton
          label={'Ask My Planner'}
          size={'sm'}
          icon={'message'}
          iconPosition={'start'}
          onClick={handleQuestionOnClick}
        />
      </FDTooltip>
    </FDBox>
  );
};

IHaveAQuestionButton.defaultProps = {
  className: '',
  completed: false,
};

IHaveAQuestionButton.propTypes = {
  className: PropTypes.string,
  completed: PropTypes.bool,
  handleQuestionOnClick: PropTypes.func.isRequired,
};

export default IHaveAQuestionButton;
